import {useTimezone} from '@/composables/use-timezone.js'
import {dateFormats} from '@/constants/date-and-time.js'
import {DateTime} from 'luxon'
import {computed, unref} from 'vue'

/**
 * Date composable
 */
export function useDate(date, format = dateFormats.DATE, locale = 'en') {

  //Get timezone
  const {timezone} = useTimezone()

  //Date time instance
  const dateTime = computed(() => {
    if (date.value instanceof DateTime) {
      return date.value.setZone(timezone.value)
    }
    return DateTime.fromISO(date.value).setZone(timezone.value)
  })

  //Computed refs
  const formattedDate = computed(() => dateTime.value.toFormat(unref(format), {locale}))
  const relativeDate = computed(() => dateTime.value.toRelativeCalendar({locale}))
  const now = computed(() => DateTime.now().setZone(timezone.value))
  const isToday = computed(() => dateTime.value.toFormat('yyyy-MM-dd') === now.value.toFormat('yyyy-MM-dd'))

  //Expose interface
  return {
    dateTime,
    formattedDate,
    relativeDate,
    isToday,
  }
}
